class PurchaseInfo extends HTMLElement {
  connectedCallback() {
    this.thresholdCents = parseInt(this.dataset.thresholdCents || '0', 10);
    this.shippingCents = parseInt(this.dataset.shippingCents || '0', 10);
    this.productCents = parseInt(this.dataset.productCents || '0', 10);
    this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
    this.progressTemplate = this.dataset.progressTemplate || '';
    this.achievedMessage = this.dataset.achievedMessage || '';
    this.freeShippingText = this.dataset.freeShippingText || '';
    this.lineTemplate = this.dataset.lineTemplate || '';
    this.cartCents = parseInt(this.dataset.cartCents || '0', 10);
    this.cartItems = null;
    try {
      this.variantPrices = JSON.parse(this.dataset.variantPrices || '{}');
    } catch (error) {
      this.variantPrices = {};
    }

    this.onUpdate = this.onUpdate.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
    document.addEventListener('cart:updated', this.onUpdate);
    document.addEventListener('change', this.onVariantChange, true);
    window.addEventListener('locationchange', this.onVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.onUpdate);
    document.removeEventListener('change', this.onVariantChange, true);
    window.removeEventListener('locationchange', this.onVariantChange);
  }

  onUpdate(event) {
    const cart = event.detail && event.detail.cart;
    if (!cart) return;
    this.cartCents = cart.total_price;
    this.cartItems = cart.items || [];
    this.render();
  }

  onVariantChange() {
    this.syncVariantPrice();
  }

  currentVariantId() {
    const input = document.querySelector(
      'product-form input[name="id"], form[action*="/cart/add"] input[name="id"]'
    );
    if (input && input.value) return input.value;
    return new URLSearchParams(window.location.search).get('variant');
  }

  syncVariantPrice(attempt = 0) {
    const id = this.currentVariantId();
    const price = id ? this.variantPrices[id] : undefined;
    if (price !== undefined && price !== this.productCents) {
      this.productCents = price;
      this.render();
      return;
    }
    if (attempt < 10) setTimeout(() => this.syncVariantPrice(attempt + 1), 100);
  }

  render() {
    this.updateShipping(this.cartCents + this.productCents);
    this.updateSummary();
  }

  formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const withDecimals = `${dollars}.${parts[1]}`;
    const noDecimals = dollars;
    return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, token) => {
      switch (token) {
        case 'amount':
          return withDecimals;
        case 'amount_no_decimals':
          return noDecimals;
        case 'amount_with_comma_separator':
          return `${parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${parts[1]}`;
        case 'amount_no_decimals_with_comma_separator':
          return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        case 'amount_with_apostrophe_separator':
          return `${parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'")}.${parts[1]}`;
        default:
          return match;
      }
    });
  }

  updateShipping(totalCents) {
    const message = this.querySelector('[data-free-shipping-bar-message]');
    if (!this.thresholdCents) return;

    const belowThreshold = totalCents < this.thresholdCents;
    if (message) {
      if (belowThreshold) {
        const remaining = this.formatMoney(this.thresholdCents - totalCents);
        message.textContent = this.progressTemplate.replace('[value]', remaining);
      } else {
        message.textContent = this.achievedMessage;
      }
    }
  }

  updateSummary() {
    const totalCents = this.cartCents + this.productCents;
    const subtotalEl = this.querySelector('[data-pi-subtotal]');
    const lineItemsEl = this.querySelector('[data-pi-line-items]');
    const shippingEl = this.querySelector('[data-pi-shipping]');
    const totalEl = this.querySelector('[data-pi-total]');
    if (!subtotalEl && !totalEl) return;

    const belowThreshold = this.thresholdCents > 0 && totalCents < this.thresholdCents;
    const shippingCents = belowThreshold ? this.shippingCents : 0;

    if (subtotalEl) subtotalEl.textContent = this.formatMoney(totalCents);
    if (lineItemsEl && this.cartItems) {
      const lines = this.cartItems.map((item) => ({
        qty: item.quantity,
        price: item.final_price,
        projected: false,
      }));
      if (this.productCents) lines.push({ qty: 1, price: this.productCents, projected: true });
      lineItemsEl.innerHTML = lines
        .map((line) => {
          const text = this.lineTemplate
            .replace('~~qty~~', line.qty)
            .replace('~~price~~', this.formatMoney(line.price));
          const span = document.createElement('span');
          span.className = 'product-purchase-info__line-item caption-s-regular';
          if (line.projected) span.setAttribute('data-pi-projected-line', '');
          span.textContent = text;
          return span.outerHTML;
        })
        .join('');
    } else if (lineItemsEl) {
      // no cart payload yet (variant switch only) — the real lines are still
      // accurate, so refresh just the projected one
      const projectedEl = lineItemsEl.querySelector('[data-pi-projected-line]');
      if (projectedEl) {
        projectedEl.textContent = this.lineTemplate
          .replace('~~qty~~', 1)
          .replace('~~price~~', this.formatMoney(this.productCents));
      }
    }
    if (shippingEl) {
      shippingEl.textContent = shippingCents > 0 ? this.formatMoney(shippingCents) : this.freeShippingText;
    }
    if (totalEl) totalEl.textContent = this.formatMoney(totalCents + shippingCents);
  }
}

if (!customElements.get('purchase-info')) {
  customElements.define('purchase-info', PurchaseInfo);
}
